<template>
  <div class="app-container rtl">
    <Toast v-if="showToast" :data="toastData"></Toast>
    <router-view />
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  import Toast from '@/components/Toast'
  export default {
    name: 'app',
    computed: {
      ...mapState('toast', ['showToast', 'toastData'])
    },
    components: {
      Toast,
    },
  }
</script>
